import { motion } from 'framer-motion'
import type React from 'react'
import type { PillsNavigationProps } from '@/types/components'

export const PillsNavigation: React.FC<PillsNavigationProps> = ({
  sections,
  activeType,
  onTypeChange,
}) => {
  return (
    <div className="mb-8">
      <div className="flex flex-wrap justify-center gap-4">
        {sections.map((section) => (
          <button
            type="button"
            key={section.id}
            onClick={() => section.active && onTypeChange(section.apiType)}
            disabled={!section.active}
            className={`relative px-4 py-2 rounded-full font-medium transition-all duration-300 ${
              section.active
                ? 'transform hover:scale-105 text-gray-700 hover:text-gray-900 cursor-pointer'
                : 'cursor-not-allowed opacity-60'
            }`}
            style={{
              transformStyle: 'preserve-3d',
            }}
          >
            {activeType === section.apiType && (
              <motion.div
                layoutId="activeIndicator"
                transition={{ type: 'spring', bounce: 0.3, duration: 0.6 }}
                className="absolute inset-0 bg-primary text-white rounded-full"
              />
            )}
            <span
              className={`relative block transition-colors duration-300 ${
                activeType === section.apiType ? 'text-white' : 'text-gray-700'
              } ${!section.active ? 'opacity-75' : ''}`}
            >
              {section.title}
              {section.comingSoon && (
                <span className="ml-2 inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800">
                  Coming Soon
                </span>
              )}
            </span>
          </button>
        ))}
      </div>
    </div>
  )
}
